import React, { ReactElement } from "react";
import { CustomModal } from "../CustomModal";
import { useTranslate } from "@obsbot/remo-i18n";
import "./index.less";

export interface ConfirmEditProps {
    visible: boolean;
    content: string;
    setVisible: (visible: boolean) => void;
    onConfirm: () => void;
    onCancel?: () => void;
}

export const ConfirmEditModal: React.FC<ConfirmEditProps> = ({
    visible,
    content,
    setVisible,
    onConfirm,
    onCancel,
}): ReactElement => {
    const t = useTranslate();
    return (
        <CustomModal
            className="ConfirmEditModal"
            footer={
                <div className="password-modal-button-group modal-button-group-center">
                    <div
                        className="normal-button"
                        onClick={() => {
                            onCancel?.();
                        }}
                    >
                        {t("cancel")}
                    </div>
                    <div className="group-modal-button-item" onClick={() => onConfirm()}>
                        {t("confirm")}
                    </div>
                </div>
            }
            open={visible}
            renderHeader={t("settings.account-setting.warning")}
            setVisible={setVisible}
            onClickClose={() => onCancel?.()}
        >
            <div className="modal-content">{content}</div>
        </CustomModal>
    );
};
